var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectCreated(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "#E7F7ED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2591_1614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0003 30.3334C18.5566 30.3334 19.8637 29.2669 20.2308 27.8249C20.3443 27.3789 20.7068 27 21.167 27H27.0003M17.0003 30.3334C15.1594 30.3334 13.667 28.841 13.667 27V16.1667C13.667 14.786 14.7863 13.6667 16.167 13.6667H24.5003C25.881 13.6667 27.0003 14.786 27.0003 16.1667V27M17.0003 30.3334H27.0003C28.5566 30.3334 29.8637 29.2669 30.2308 27.8249C30.3443 27.3789 29.9606 27 29.5003 27H27.0003M17.8337 20.3334L19.2943 21.5019C19.6426 21.7805 20.1484 21.7355 20.4421 21.3999L22.8337 18.6667",
    stroke: "#088B3A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2591_1614"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCreated);
export default __webpack_public_path__ + "static/media/project_created.0dcaf73f4435abea777adb835db6466f.svg";
export { ForwardRef as ReactComponent };